module.exports = __webpack_public_path__ + "img/campSummary.4a76183d.svg";